/* global __webpack_public_path__ */
export default function setPublicPath(path) {
    __webpack_public_path__ = path;
}
